module.exports = __webpack_public_path__ + "img/BASEBALL CAP GREEN.63c07b6.svg";